import * as React from 'react'
import {Link} from "gatsby"

const Overlay = () => {
    return (
        <div>
            <div className="pop-up-media">
                <figure>
                    <img alt="" className="ort-img" src={"/images/Muenchen-Prannestr/teaser-prannerstrasse.jpg"}/>
                    <figcaption>
                        Quelle: Bildarchiv Bayerischer Landtag
                    </figcaption>
                </figure>
            </div>
            <div className="pop-up-body">
                <p className='ort-header'>
                    1818–1933: München – Prannerstraße 8 </p>
                <p className="ort-subheader">
                    <i>„Für das ganze Königreich besteht eine allgemeine in zwey Kammern abgetheilte
                       Stände-Versammlung.“</i>
                </p>
                <Link to="/orte/muenchen-prannerstrasse/" className='ort-text icon-arrow-right load-infobox'>
                    Mehr erfahren
                </Link>
            </div>

        </div>
    )
}

export default Overlay

